import React from 'react';
interface BaGuaTabProps {
  searchTerm: string;
}
export function BaGuaTab({
  searchTerm
}: BaGuaTabProps) {
  return <div className="bg-gray-50 p-6 rounded-xl shadow-md" data-id="element-108">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 pb-3 border-b-4 border-purple-600" data-id="element-109">
        Meridian Ba Gua Conversion
      </h2>
      <div className="bg-white p-6 rounded-xl shadow-md mb-8" data-id="element-110">
        <p className="text-gray-700 leading-relaxed" data-id="element-111">
          Ba Gua Conversion is an advanced technique that uses the Eight
          Trigrams (Ba Gua) system to select treatment meridians. Each
          conversion pattern creates specific relationships between channels for
          targeted therapeutic effects.
        </p>
      </div>
      <div className="space-y-6" data-id="element-112">
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-113">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-114">
            Yang Ming Ba Gua Conversion (I IV Pattern)
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-115">
            <strong className="text-blue-800" data-id="element-116">Pattern:</strong>
            <span className="text-blue-700" data-id="element-117"> I IV</span>
            <br data-id="element-118" />
            <strong className="text-blue-800" data-id="element-119">Description:</strong>
            <span className="text-blue-700" data-id="element-120">
              {' '}
              4 Magic Meridians mixed with Sp-He Shao Yang
            </span>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-121">
            <strong className="text-purple-800" data-id="element-122">
              Four Magic Meridians in Yang Ming:
            </strong>
            <ul className="mt-2 space-y-1 text-purple-700" data-id="element-123">
              <li data-id="element-124">
                • <strong data-id="element-125">Pericardium (I)</strong> ↔{' '}
                <strong data-id="element-126">Stomach (IV)</strong>
              </li>
              <li data-id="element-127">
                • <strong data-id="element-128">Liver</strong> ↔ <strong data-id="element-129">Kidney</strong>
              </li>
            </ul>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-130">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-131">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-132">
                CONVERSION APPROACH
              </h4>
              <div className="space-y-2" data-id="element-133">
                {['Use PC for ST problems', 'Use ST for PC problems', 'Use LIV for KI problems', 'Use KI for LIV problems'].map((item, index) => <div key={index} className="px-3 py-2 bg-blue-100 rounded text-sm" data-id="element-134">
                    {item}
                  </div>)}
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-135">
              <h4 className="font-semibold text-green-800 mb-3" data-id="element-136">
                CLINICAL APPLICATIONS
              </h4>
              <div className="space-y-2" data-id="element-137">
                {['Front body symptoms', 'Digestive disorders', 'Chest pain', 'Abdominal issues'].map((item, index) => <div key={index} className="px-3 py-2 bg-green-100 rounded text-sm" data-id="element-138">
                    {item}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-139">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-140">
            Shao Yang Ba Gua Conversion (III VI Pattern)
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-141">
            <strong className="text-blue-800" data-id="element-142">Pattern:</strong>
            <span className="text-blue-700" data-id="element-143"> III VI</span>
            <br data-id="element-144" />
            <strong className="text-blue-800" data-id="element-145">Primary Use:</strong>
            <span className="text-blue-700" data-id="element-146">
              {' '}
              For Gallbladder and Heart conditions
            </span>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-147">
            <strong className="text-purple-800" data-id="element-148">
              Shao Yang Conversion Pairs:
            </strong>
            <ul className="mt-2 space-y-1 text-purple-700" data-id="element-149">
              <li data-id="element-150">
                • <strong data-id="element-151">Triple Heater (III)</strong> ↔{' '}
                <strong data-id="element-152">Gallbladder (VI)</strong>
              </li>
              <li data-id="element-153">
                • <strong data-id="element-154">Heart</strong> ↔ <strong data-id="element-155">Spleen</strong>
              </li>
            </ul>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-156">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-157">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-158">
                CONVERSION APPROACH
              </h4>
              <div className="space-y-2" data-id="element-159">
                {['Use TH for GB problems', 'Use GB for TH problems', 'Use HT for SP problems', 'Use SP for HT problems'].map((item, index) => <div key={index} className="px-3 py-2 bg-blue-100 rounded text-sm" data-id="element-160">
                    {item}
                  </div>)}
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-161">
              <h4 className="font-semibold text-green-800 mb-3" data-id="element-162">
                CLINICAL APPLICATIONS
              </h4>
              <div className="space-y-2" data-id="element-163">
                {['Lateral body symptoms', 'Rib pain', 'Temple headaches', 'Side neck pain'].map((item, index) => <div key={index} className="px-3 py-2 bg-green-100 rounded text-sm" data-id="element-164">
                    {item}
                  </div>)}
              </div>
            </div>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-165">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-166">
            OBGYN Ba Gua Conversion - Special Protocols
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-167">
            <strong className="text-blue-800" data-id="element-168">
              For all gynecological conditions, menstrual disorders, and
              reproductive health
            </strong>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-169">
            <strong className="text-purple-800" data-id="element-170">Two Main Patterns:</strong>
            <ul className="mt-2 space-y-1 text-purple-700" data-id="element-171">
              <li data-id="element-172">
                • <strong data-id="element-173">Pattern 1 (I IV):</strong> San Jiao and Spleen
              </li>
              <li data-id="element-174">
                • <strong data-id="element-175">Pattern 2 (III VI):</strong> Gallbladder and Heart
              </li>
            </ul>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-176">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-177">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-178">
                PRIMARY OBGYN POINTS
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-179">
                {['TH-1', 'TH-4', 'SP-1', 'SP-4', 'SP-6'].map(point => <span key={point} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-180">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-red-50 p-4 rounded-lg" data-id="element-181">
              <h4 className="font-semibold text-red-800 mb-3" data-id="element-182">
                SECONDARY BALANCE
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-183">
                {['GB-34', 'GB-41', 'HT-3', 'HT-7'].map(point => <span key={point} className="px-3 py-1 bg-red-200 text-red-800 rounded-full text-sm font-medium" data-id="element-184">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4 mt-4" data-id="element-185">
            <strong className="text-yellow-800" data-id="element-186">Special Techniques:</strong>
            <ul className="mt-2 space-y-1 text-yellow-700" data-id="element-187">
              <li data-id="element-188">
                • <strong data-id="element-189">Jing Well Reduction:</strong> Can reduce Jing Wells
                (fingers/toes) for excess patterns
              </li>
              <li data-id="element-190">
                • <strong data-id="element-191">Horizontal Substitution:</strong> Substitute points on
                same level across meridians
              </li>
            </ul>
          </div>
        </div>
        <div className="bg-white p-6 rounded-xl shadow-md" data-id="element-192">
          <h3 className="text-2xl font-bold text-teal-700 mb-3" data-id="element-193">
            Male Issues Ba Gua Balance
          </h3>
          <div className="bg-blue-50 p-4 rounded-lg mb-4" data-id="element-194">
            <strong className="text-blue-800" data-id="element-195">
              For prostate, urinary problems, erectile dysfunction, and male
              reproductive health
            </strong>
          </div>
          <div className="bg-purple-50 p-4 rounded-lg mb-4" data-id="element-196">
            <strong className="text-purple-800" data-id="element-197">Three Key Meridians:</strong>
            <span className="text-purple-700" data-id="element-198">
              {' '}
              Large Intestine - Kidney - Stomach (Li-Ki-St)
            </span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-199">
            <div className="bg-blue-50 p-4 rounded-lg" data-id="element-200">
              <h4 className="font-semibold text-blue-800 mb-3" data-id="element-201">
                PRIMARY TREATMENT POINTS
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-202">
                {['LI-4', 'LI-11', 'KI-3', 'KI-7', 'KI-10'].map(point => <span key={point} className="px-3 py-1 bg-blue-200 text-blue-800 rounded-full text-sm font-medium" data-id="element-203">
                    {point}
                  </span>)}
              </div>
            </div>
            <div className="bg-green-50 p-4 rounded-lg" data-id="element-204">
              <h4 className="font-semibold text-green-800 mb-3" data-id="element-205">
                STOMACH SUPPORT
              </h4>
              <div className="flex flex-wrap gap-2" data-id="element-206">
                {['ST-36', 'ST-41', 'ST-43'].map(point => <span key={point} className="px-3 py-1 bg-green-200 text-green-800 rounded-full text-sm font-medium" data-id="element-207">
                    {point}
                  </span>)}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-orange-50 border-l-4 border-orange-500 p-6 mt-8" data-id="element-208">
        <strong className="text-orange-800 text-lg" data-id="element-209">
          Advanced Ba Gua Techniques:
        </strong>
        <ul className="mt-3 space-y-2 text-orange-700" data-id="element-210">
          <li data-id="element-211">
            • <strong data-id="element-212">Jing Well Reduction:</strong> Use Jing Well points
            (fingers/toes) to reduce excess conditions through horizontal
            substitution
          </li>
          <li data-id="element-213">
            • <strong data-id="element-214">Horizontal Substitution:</strong> Replace points with same
            anatomical level on related meridians
          </li>
          <li data-id="element-215">
            • <strong data-id="element-216">Truss Structure:</strong> Combine Ba Gua with Global
            Balance truss formations
          </li>
          <li data-id="element-217">
            • <strong data-id="element-218">Layering:</strong> Add Ba Gua conversions to seasonal
            protocols for complex cases
          </li>
        </ul>
      </div>
    </div>;
}